var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgTweet(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#00AAEC",
    d: "M24 11.539a6.539 6.539 0 01-1.885.516 3.288 3.288 0 001.444-1.815 6.564 6.564 0 01-2.086.796 3.282 3.282 0 00-5.593 2.993 9.317 9.317 0 01-6.766-3.43 3.277 3.277 0 00-.444 1.652 3.28 3.28 0 001.46 2.731 3.285 3.285 0 01-1.488-.41v.041a3.283 3.283 0 002.635 3.218 3.268 3.268 0 01-1.483.057 3.283 3.283 0 003.066 2.278 6.585 6.585 0 01-4.077 1.406c-.265 0-.527-.015-.783-.045A9.308 9.308 0 0013.032 23c6.038 0 9.34-5 9.34-9.337 0-.143-.003-.286-.009-.425A6.64 6.64 0 0024 11.539"
  }));
}

export default SvgTweet;